import { QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';
import { ME_KEY } from './me';

/** Shared QueryClient: no retries on 4xx; a 402/401 refreshes `me` so banners and guards update. */
export function createQueryClient(): QueryClient {
  const qc: QueryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (err, query) => {
        if (err instanceof ApiError && (err.code === 'workspace_inactive' || err.status === 401) && query.queryKey[0] !== ME_KEY[0]) {
          void qc.invalidateQueries({ queryKey: ME_KEY });
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
      },
      mutations: { retry: false },
    },
  });
  return qc;
}
